<script>

export default {
  name: "AudioWindow",
  data() {
    return {
      isShow: false,
      startX: 0,
      startY: 0
    }
  },
  props: ['pic', 'playStatus'],
  methods: {
    initPos() {
      let elParent = $(".drag-parent");
      let el = $("#box");
      let parentWidth = elParent.width();
      let parentHeight = elParent.height();
      let initTop = parentHeight - el.height() - 50;
      let initLeft = parentWidth - el.width();
      el.css("left", initLeft);
      el.css("top", initTop);
    },
    onClick(e) {
      const endX = e.changedTouches[0].pageX;
      const endY = e.changedTouches[0].pageY;
      const dx = Math.abs(endX - this.startX);
      const dy = Math.abs(endY - this.startY);

      if (dx < 10 && dy < 10) {
        console.log("触发点击")
        this.$emit("click");
        e.preventDefault();
      }
    },
    onTouchStart(e) {
      this.startX = e.touches[0].pageX;
      this.startY = e.touches[0].pageY;
    },
    hidden() {
      this.isShow = false;
    },
    show() {
      this.isShow = true;
    },
    onChangeStatus(status) {
      this.$emit("change", status);
    },
    onClickStop() {
      this.$emit("stop");
      this.hidden();
    }
  },
  mounted() {
    this.initPos();
    let windowWidth = document.documentElement.clientWidth;
    let windowMiddle = windowWidth / 2;
    $( "#box" ).draggable({
      containment: ".drag-parent",
      stop: function(event) {
        let left = event.clientX;
        let top = event.clientY;
        if (left > windowMiddle) {
          $(this).css("left", windowWidth - $(this).width());
        } else {
          $(this).css("left", 0);
        }
      }
    });
  }
};
</script>

<template>
  <div v-show="isShow" id="box" class="audio-window">
    <div class="content bg-gray-600 shadow p-2">
      <div class="mb-2 border-b border-white pb-2">
        <img :src="pic" alt="" class="w-12 h-12 avatar" @touchstart="onTouchStart" @touchend="onClick" style="border-radius: 50%">
      </div>
      <div class="flex justify-between items-center text-white">
        <div>
          <van-icon v-if="!playStatus" name="play" @touchend.stop="onChangeStatus(false)"/>
          <van-icon v-else name="pause" @touchend.stop="onChangeStatus(true)"/>
        </div>
        <van-icon name="cross" @touchend.stop="onClickStop"/>
      </div>
    </div>
  </div>
</template>

<style scoped>
.audio-window {
  position: absolute;
  pointer-events: auto;
}

.avatar {
  /**animation: animationName 5s infinite linear;**/
}

@keyframes animationName {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
